import styled from "styled-components";

export const ToolTipStyles = styled.div`
  background: ${({ theme }) => theme.secondaryButtonBackground};
  // border-bottom: 1px dotted ${({ theme }) => theme.secondaryButtonBackground};
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);

  &::after {
    border-color: ${({ theme }) => theme.secondaryButtonBackground} transparent transparent transparent; /* Arrow border color */
  }
`;